export default __webpack_public_path__ + "static/media/transactions.bb2a211b.svg";